const getEnv = (name: string): string => {
  const value = import.meta.env[name] as string;
  if (!value) {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
};

export const getOptionalEnv = (name: string): string | undefined => {
  const value = import.meta.env[name] as string | undefined;
  return value || undefined;
};

/**
 * Returns the mops-api base URL. An empty string means same-origin (relative URLs),
 * which is how the CloudFront deploy talks to the admin Lambda via the distribution's
 * `/graphql` + `/auth/*` behaviors. Local dev sets this to
 * `http://localhost:${MOPS_API_PORT}` via `vite.config.ts`.
 *
 * Use this helper instead of `getEnv('VITE_API_SERVER_URL')` — the latter
 * throws when the value is an empty string, which breaks same-origin builds.
 */
export const getApiBaseUrl = (): string => {
  const value = import.meta.env.VITE_API_SERVER_URL as string | undefined;
  return value ?? '';
};

export default getEnv;
